import { render, staticRenderFns } from "./CurrentFilters.vue?vue&type=template&id=2e7d5f67&"
import script from "./CurrentFilters.vue?vue&type=script&lang=js&"
export * from "./CurrentFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports